module.exports = __webpack_public_path__ + "img/key-fill.a823b42d.svg";